import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params, Router }   from '@angular/router';
import { Http, Response, ResponseContentType } from '@angular/http';



import { ProviderService } from '../../services/providers/provider.service';
import { CountryService } from '../../services/country/country.service';
import { PlanService } from '../../services/plans/plan.service';
import { RequestService } from '../../services/request.service';

import { saveAs } from 'file-saver';



import { Provider } from '../../classes/provider';
import { Doctor } from '../../classes/doctor';
import { Country } from '../../classes/country';


import * as XLSX from 'xlsx/types';
import { forEach } from '@angular/router/src/utils/collection';
import vkbeautify from 'vkbeautify';
import { SpecialtyProviderConfigService } from '../../services/specialtyProviderConfig/specialty-provider-config.service';
import * as _ from 'lodash';
import { Auth } from '../../services/auth.service';
var MomentTimezone = require('moment-timezone');

type AOA = Array<Array<any>>;

function s2ab(s: string): ArrayBuffer {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF;
  };
  return buf;
}


interface FileReaderEventTarget extends EventTarget {
  result:string
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage():string;
}

const MILISECONDS = 60000

@Component({
  selector: 'provider',
  templateUrl: './provider.component.html',
  styleUrls: ['./provider.component.css']
})
export class ProviderComponent implements OnInit {

  provider: Provider = new Provider()
  doctors: Doctor[]
  providerDoctors:Doctor[]
  specialties:any[]
  providerSpecialties:any[]
  specialtiesMaxTime:any[];
  specialtiesProviderConfig:any[];
  plans:any[]
  providerPlans:any[]
  languages:string[]
  allSupportedLanguages: any[]
  countries:any[]
  timezones:string[] = MomentTimezone.tz.names();

  originalProvider: Provider;
  loading:boolean=false

  service:string
  serviceObject:any
  services:any[]
  extraFields:any[]

  image: string;

  url:string
  urlHeader:string
  urlLoginValidatorImage:string
  urlRegistrationSelectorImage:string
  urlPrescriptionLogo:string
  urlAppointmentMailLogo:string
  urlCallBackgroundImage:string

  appointmentEmailAttachments:any[]

  imageChanged:boolean=false
  headerChanged:boolean=false
  loginValidatorImageChanged:boolean=false
  registrationSelectorImageChanged:boolean=false
  prescriptionLogoChanged:boolean=false
  appointmentMailLogoChanged:boolean=false
  callBackgroundImageChanged:boolean=false
  customStyleSheetUrlChanged:boolean=false
  formData:any=new FormData()

  htmlTC:string=""
  TC = {};
  TCFromDB = {};
  loginValidatorTextHeader:string=""
  loginValidatorTextFooter:string=""

  details:any

  useFarmalink:boolean = false;
  useMedikit:boolean = false;
  prescriptionIntegrationChanged:boolean = false
  initialPrescriptionIntegrationType
  newPrescriptionIntegrationType

  supportsCustomQuestions: boolean = false;

  defaultValidatorToAdd:string;
  defaultValidators:string[];

  documentNumber:number
  validator:string
  serviceResponse:any

  priorityCountryEmptyItemText:string="All countries";
  priorityCountry:string= this.priorityCountryEmptyItemText;

  uploadNow = {
    affiliates: false,
    monitoring: false
  };

  medicinesTable = []

  useOwnVademecum:boolean = false;
  vademecumType:string;
  questions: any[] = []
  allusers = false;

  //affiliates: any //List of JSON objects with imported affiliates

  public editorTC;
  public editorTCContent = `<h3>I am Example content</h3>`;
  public editorTCOptions = {
    placeholder: "Insert TC"
  };

  public editorPrescription;
  public editorPrescriptionContent = `<h3>I am Example content</h3>`;
  public editorPrescriptionOptions = {
    placeholder: "Insert Prescription model"
  };
  public editorCertificateOptions = {
    placeholder: "Insert Assistance Certificate model"
  };

  public editorMail;
  public editorMailContent = `<h3>I am Example content</h3>`;
  public editorMailOptions = {
    placeholder: "Insert mail for prescription model"
  };

  hasWriteProviderPermission:boolean = false;
  hasReportsPermission:boolean = false;
  hasWriteDoctorPermission = false;

  constructor(protected providerService: ProviderService,
    protected route: ActivatedRoute,
    protected planService:PlanService,
    protected countryService:CountryService,
    protected requestService:RequestService,
    protected router: Router,
    private http: Http,
    protected specialtyProviderService:SpecialtyProviderConfigService,
    protected auth: Auth) { }

  ngOnInit() {
    this.startTCEditor()
    this.hasWriteProviderPermission = this.auth.hasWriteProviderPermission();
    this.hasReportsPermission = this.auth.hasReportsPermission();
    this.hasWriteDoctorPermission = this.auth.hasWriteDoctorPermission();
    if(!this.hasWriteProviderPermission){
      $(document).ready (() => {
        var inputs = document.getElementsByTagName('input');
        var selects = document.getElementsByTagName('select');
        var textareas = document.getElementsByTagName('textarea');
        Array.from(inputs).forEach((input) => input.setAttribute("disabled",""));
        Array.from(selects).forEach((select) => select.setAttribute("disabled",""));
        Array.from(textareas).forEach((textarea) => textarea.setAttribute("disabled",""));
      })
    }

    this.route.params
      .switchMap((params: Params) => this.providerService.getOne(params['id']))
      .subscribe((provider) => {
        this.provider = new Provider(provider);
        this.initialPrescriptionIntegrationType = this.provider.prescriptionIntegrationType
        this.useFarmalink = this.provider.prescriptionIntegrationType == 'Farmalink';
        this.useMedikit = this.provider.prescriptionIntegrationType == 'Medikit';
        this.urlHeader=provider["header"]
        this.url=provider["image"]
        this.loginValidatorTextHeader = provider.loginValidatorTextHeader
        this.loginValidatorTextFooter = provider.loginValidatorTextFooter
        this.urlLoginValidatorImage = provider.loginValidatorImage
        this.urlRegistrationSelectorImage = provider.registrationSelectorImage
        this.urlPrescriptionLogo = provider.prescriptionLogo
        this.urlAppointmentMailLogo = provider.appointmentMailLogo
        this.urlCallBackgroundImage = provider.callBackgroundImage
        this.defaultValidators = !_.isEmpty(provider.defaultValidators) ? Object.keys(provider.defaultValidators).map(key => provider.defaultValidators[key]) : [];
        this.supportsCustomQuestions = provider.supportsCustomQuestions || false
        this.startPrescriptionEditor()
        this.startMailEditor()

        this.providerService.getTC(provider.id).then((TCs)=>{
          TCs.forEach( tc => {
              this.TCFromDB[tc.language] = {id: tc.id}
              this.TC[tc.language] = tc.body
          })
        })

        this.countryService.getAll().then((countries) => {
          this.countries = countries;
        })
        this.providerService.getDetails(provider.id).then((response)=>{
          this.details=response
        })
        this.providerService.getServices().then((response)=>{
          this.services=response
          this.findMyService()
        })
        this.providerService.getDoctors(provider.id).then((response)=>{
          this.providerDoctors = response
        })
        this.providerService.getDoctorsWhoDontBelong(provider.id).then((response)=>{
          this.doctors=response
        })
        this.providerService.getSpecialties(provider.id).then((response)=>{
          this.providerSpecialties = response
          this.specialtiesMaxTime = new Array(this.providerSpecialties.length);
          this.specialtyProviderService.getByProvider(provider.id).then((configs)=>{
            this.specialtiesProviderConfig = configs

            for (let i = 0; i < this.providerSpecialties.length; i++) {
            forEach
              this.specialtiesProviderConfig.forEach(config => {
                if(this.providerSpecialties[i].realId == config.specialty)
                {
                  this.specialtiesMaxTime[i] = config.maxDuration/MILISECONDS;
                }
              });
            }
          })
        })
        this.providerService.getSpecialtiesNotInProvider(provider.id).then((response)=>{
          this.specialties = response
        })
        this.providerService.getPlans(provider.id).then((response)=>{
          this.providerPlans = response
        })
        this.providerService.getPlansNotInProvider(provider.id).then((response)=>{
          this.plans = response
        })
        this.providerService.getLanguages().then((languages)=>{
          this.languages = languages;
        })
        this.providerService.getProviderLanguages().then((supportedLanguages) =>{
          this.allSupportedLanguages = supportedLanguages;
        })
        this.providerService.getSatisfactionSurveyQuestions(this.provider.id).then((satisfactionSurveyQuestions)=>{
          this.questions = satisfactionSurveyQuestions
          this.questions.forEach(element => {
            element['textType'] = element.type == "string" ? true : false
          });
        })
        this.providerService.getAppointmentAttachments(this.provider.id).then(appointmentAttachments =>{
          this.appointmentEmailAttachments = appointmentAttachments;
        })

        var defaultMedicinesTable = [
          {name:"Nombre:", value:"active"},
          {name:"Nombre genérico:", value:"drugs"},
          {name:"Presentación:", value:"packaging"},
          {name:"Dosis:", value:"pot"},
          {name:"Forma Farmacéutica:", value:"form"},
          {name:"Cantidad:", value:"cont"},
          {name:"Cantidad de envases:", value:"quantity"}
        ]
        if(!this.provider.prescriptionMedicinesModel)
        {
          this.medicinesTable = defaultMedicinesTable;
          this.provider.prescriptionMedicinesModel = []
        }
        else
        {
          defaultMedicinesTable.forEach(medicine => {
            var inlist = false;
            this.provider.prescriptionMedicinesModel.forEach(element => {
              if(medicine.value==element.value)
                inlist = true
            });
            if(!inlist)
              this.medicinesTable.push(medicine)
          })
        }
      })
  }

  findMyService(){
    let service = this.services[0]
    let i=0
    while (service.file!=this.provider.serviceObjectName) {
      i++
      service = this.services[i]
    }
    this.serviceObject = service
    this.extraFields = this.serviceObject.extraFields
  }

  edit() {
    this.originalProvider = new Provider(this.provider);
    if (!this.provider.minAge) this.provider.minAge = 0
    if (this.provider.supportsPrescription) {
      this.editorPrescription.enable()
      this.editorMail.enable()
    }
  }

  save() {
    let promises=[]

    if (this.imageFileAdded()){
      promises.push(this.providerService.updateImage(this.provider.id,this.formData,'providerUploadImage'))
    }

    this.prescriptionIntegrationChanged = this.initialPrescriptionIntegrationType != this.newPrescriptionIntegrationType;

    if(this.prescriptionIntegrationChanged) {
      this.provider.prescriptionIntegrationType = this.newPrescriptionIntegrationType;
    }

    if(this.supportsCustomQuestions != this.provider.supportsCustomQuestions) {
      if(this.supportsCustomQuestions && this.questions.length == 0) {
        alert("Missing attributes related with custom questions")
        return null
      }
      else{
        let emptyQuestion=false;
        this.questions.forEach(element => {
          emptyQuestion = element.question=="" ? true : false
        });
        if(!emptyQuestion)
          this.provider.supportsCustomQuestions = this.supportsCustomQuestions;
        else
        {
          alert("One of the questions is empty")
          return null
        }
      }
    }
    if(this.questions.length != 0)
    {
      this.questions.forEach(element => {
        if(element.textType)
        {
          element.type = "string"
          delete element.textType
        }
      });
      this.provider.satisfactionSurveyQuestions = this.questions;
    }

    promises.push(this.providerService.update(this.provider))
    Promise.all(promises).then((response)=>{
      window.location.reload()
    }).catch((err)=>{
      console.log("err",err);
      alert(err.json().message);
    })
  }

  saveTC(languageId, upgradeVersion){
    var TCPromise;
    if(!this.TCFromDB[languageId]){
      TCPromise = this.providerService.createTC({
        provider: this.provider.id,
        language: languageId,
        body: this.TC[languageId],
        upgradeVersion: upgradeVersion
      })
    } else {
      TCPromise = this.providerService.updateTC(this.TCFromDB[languageId].id, {
        body: this.TC[languageId],
        upgradeVersion: upgradeVersion
      })
    }

    return TCPromise.then(async()=>{
      await this.providerService.getTC(this.provider.id).then((TCs)=>{
        TCs.forEach( tc => {
            this.TCFromDB[tc.language] = {id: tc.id}
        })
      })
      alert("Provider TC updated")
    })

  }

  saveLoginValidatorInfo(){
    let promises=[]
    this.provider['loginValidatorTextHeader']=this.loginValidatorTextHeader
    this.provider['loginValidatorTextFooter']=this.loginValidatorTextFooter
    promises.push(this.providerService.update(this.provider))
    if (this.loginValidatorImageChanged){
      promises.push(this.providerService.updateImage(this.provider.id,this.formData,'providerUploadImage'))
    }
    Promise.all(promises).then((response)=>{
      window.location.reload()
    }).catch((err)=>{
      console.log("err",err);
      alert(err.json().message);
    })
  }

  cancel() {
    this.provider = this.originalProvider;
  }

  changeLogo($ev:any){

    var inputValue = $ev.target;
    let file = inputValue.files[0];

    this.formData.set("image",  file);
    this.imageChanged=true
    this.readUrl($ev);
  }

  changeHeader($ev:any){

    var inputValue = $ev.target;
    let file = inputValue.files[0];
    let reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          window.URL.revokeObjectURL(img.src);

          if (width >= 390 && height >= 90){
            if (width >= 3*height && width <= 5*height){
               this.formData.set("header", file);
               this.headerChanged = true;
               this.readHeaderUrl($ev);
            } else {
              alert("ERROR. El ancho debe ser aproximadamente 4 veces el alto. La imagen subida es de " + width + "x" + height + " pixeles.")
            }
          } else {
            alert("ERROR. El tamaño mínimo es de 390x90 pixeles. La imagen subida es de " + width + "x" + height + " pixeles.")
          }
        }
      }
    }
  }

  changeLoginValidatorImage($ev:any){
    var inputValue = $ev.target;
    let file = inputValue.files[0];
    let reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          window.URL.revokeObjectURL(img.src);
          if ((width >= 760 && width <= 840) && (height >= 470 && height <= 530)){
            this.formData.set("loginValidatorImage",  file);
            this.loginValidatorImageChanged=true;
            this.readLoginValidatorImageUrl($ev);
          } else {
             alert("ERROR. El tamaño de la imagen debe ser de 800x500 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
          }
        }
      }
    }
  }

  changeRegistrationSelectorImage($ev:any){
    var inputValue = $ev.target;
    let file = inputValue.files[0];
    let reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          window.URL.revokeObjectURL(img.src);
          if ((width >= 270 && width <= 330) && (height >= 150 && height <= 190)){
            this.formData.set("registrationSelectorImage",  file);
            this.registrationSelectorImageChanged=true;
            this.readRegistrationSelectorImageUrl($ev);
          } else {
            alert("ERROR. El tamaño de la imagen debe ser de 300x170 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
         }
        }
      }
    }
  }

  changePrescriptionLogo($ev:any){
    var inputValue = $ev.target;
    let file = inputValue.files[0];
    let reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          window.URL.revokeObjectURL(img.src);
          if ((width >= 270 && width <= 330) && (height >= 150 && height <= 190)){
            this.formData.set("prescriptionLogo",  file);
            this.prescriptionLogoChanged=true;
            this.readPrescriptionLogoUrl($ev);
          } else {
            alert("ERROR. El tamaño de la imagen debe ser de 320x160 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
         }
        }
      }
    }
  }

  changeAppointmentMailLogo($ev:any){
    var inputValue = $ev.target;
    let file = inputValue.files[0];
    let reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          window.URL.revokeObjectURL(img.src);
          if ((width >= 790 && width <= 810) && (height >= 440 && height <= 450)){
            this.formData.set("appointmentMailLogo",  file);
            this.appointmentMailLogoChanged=true;
            this.readAppointmentMailLogoUrl($ev);
          } else {
            alert("ERROR. El tamaño de la imagen debe ser de aproximadamente 800x446 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
         }
        }
      }
    }
  }

  changeCallBackgroundImage($ev:any){
    var inputValue = $ev.target;
    let file = inputValue.files[0];
    let reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          console.log(width)
          console.log(height)
          window.URL.revokeObjectURL(img.src);
          if ((width >= 790 && width <= 810) && (height >= 440 && height <= 450)){
            this.formData.set("callBackgroundImage",  file);
            this.callBackgroundImageChanged=true;
            if ($ev.target.files && $ev.target.files[0]) {
              var reader = new FileReader();
              reader.onload = (event:FileReaderEvent) => {
                this.urlCallBackgroundImage = event.target.result;
              }
              reader.readAsDataURL($ev.target.files[0]);
            }
          } else {
            alert("ERROR. El tamaño de la imagen debe ser de aproximadamente 800x446 pixeles. La imagen subida es de " +width+" x " +height+ " pixeles.")
         }
        }
      }
    }
  }

  changeCustomStyles($ev:any){
    var inputValue = $ev.target;
    let file = inputValue.files[0];
    let reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.formData.set("customStyleSheetUrl",  file);
        this.customStyleSheetUrlChanged=true;
        let event = $ev
        if (event.target.files && event.target.files[0]) {
          var reader = new FileReader();
          reader.onload = (event:FileReaderEvent) => {
            this.provider.customStyleSheetUrl = event.target.result;
          }
          reader.readAsDataURL(event.target.files[0]);
        }
      }
    }
  }

  changeAuthenticationType(value:any){
    if (value == "oauth2" &&
        !confirm("By changing the authentication type to oauth2 the provider will have to send a client_id and client_secret on every token and appointment request.\nDon't change this if you don't know what you are doing.\nConfirm the change please.")) {
      let el = document.getElementById("authenticationType")
      el.querySelectorAll('option')[0].selected = true;
      this.provider.authenticationType = "none";
    } else {
      this.provider.authenticationType = value;
    }
  }

  readUrl(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:FileReaderEvent) => {
        this.url = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  readHeaderUrl(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:FileReaderEvent) => {
        this.urlHeader = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  readLoginValidatorImageUrl(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:FileReaderEvent) => {
        this.urlLoginValidatorImage = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  readRegistrationSelectorImageUrl(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:FileReaderEvent) => {
        this.urlRegistrationSelectorImage = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  readPrescriptionLogoUrl(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:FileReaderEvent) => {
        this.urlPrescriptionLogo = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  readAppointmentMailLogoUrl(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:FileReaderEvent) => {
        this.urlAppointmentMailLogo = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  onFileChange(evt: any,field) {
    var inputValue = evt.target;
    let file = inputValue.files[0];
    let uploadExcelNow = this.uploadNow[field.name];
    var formData =new FormData();
    inputValue.value = '';
    formData.append(field.name,file)
    this.providerService.updateExtraField(this.provider.id,field.endpoint,formData, uploadExcelNow, this.allusers)
    .then((response)=>{
      response = JSON.parse(response);
      let res =""
      Object.keys(response).forEach(function(key) {
        res+=key+":"+response[key]+"\n"
      })
      if(field.name =="affiliates"){
        if (uploadExcelNow) {
          res += 'El excel se procesará ahora.'
        } else {
          res += 'El excel se procesará a la 1 AM.'
        }
      }
      alert(res)
    }).catch((err)=>{
      alert('Error: '+err)
    })
  }


  onVademecumChange(evt: any) {
    var inputValue = evt.target;
    let file = inputValue.files[0];
    var formData =new FormData();
    inputValue.value = '';
    if(this.vademecumType == undefined) {
      alert('Select a vademecum type')
      return
    }
    formData.append("vademecumType",this.vademecumType)
    formData.append("vademecum",file)
    this.providerService.updateVademecum(this.provider.id, formData)
    .then((response)=>{
      response = JSON.parse(response);
      let res =""
      Object.keys(response).forEach(function(key) {
        res+=key+":"+response[key]+"\n"
      })
      alert(res)
    }).catch((err)=>{
      alert('Error: '+err)
    })
  }

  onAppointmentAttachmentsChange(evt: any) {
    var inputValue = evt.target;
    let file = inputValue.files[0];
    var attachments = this.appointmentEmailAttachments || [];
    var repeated = attachments.find(attachment => {
        return attachment.fileName == file.name
    })
    if(repeated){
      alert("Ya existe un archivo con ese nombre.");
      inputValue.value = '';
      return;
    }

    var formData = new FormData();
    inputValue.value = '';
    formData.append("appointmentAttachment",file)
    this.providerService.updateAppointmentAttachments(this.provider.id, formData)
    .then((response)=>{
      this.appointmentEmailAttachments.push(response)
    }).catch((err)=>{
      var error = JSON.parse(err)
      alert('Error: ' + error.message)
    })
  }

  removeAttachment(fileName) {
    this.providerService.removeAppointmentAttachments(this.provider.id, fileName).then( response => {
      this.appointmentEmailAttachments = this.appointmentEmailAttachments.filter(function( fileItem ) {
        return fileItem.fileName !== response.fileName;
      });
    })
  }

  changeExtraField(field){
    this.providerService.useExtraField(this.provider.id,field.endpoint).then((response)=>{
      console.log(response)
    })
  }
  download(field) {
    var requestParams = {
      method: 'get',
      asObservable: true,
      responseType: ResponseContentType.Blob,
      urlParams: {
        id: this.provider.id,
      },
    }

    this.requestService.makeRequest(requestParams,field.endpoint)
    .subscribe((response)=>{
      alert("Los datos están siendo procesados, en unos minutos llegará un mail con los excel solicitados.")
    })
  }

  checkIfPatientExistsInWebService(field){
    var useSOAP =false;
    this.extraFields.forEach(element => {
      if(element.type== "checkIfPatientExistsInWebService" && element.useSOAP)
      {
        useSOAP = true;
      }
    });

    var requestParams = {
      method: 'get',
      responseType: useSOAP ? ResponseContentType.Text: ResponseContentType.Json,
      urlParams: {
        id: this.provider.id,
        documentNumber: this.documentNumber,
        validator: this.validator
      },
    }
    this.requestService.makeRequest(requestParams,field.endpoint)
    .then((response:any)=>{
      if (useSOAP){
         response = vkbeautify.xml(response._body)
      } else {
        response = JSON.stringify(response._body,null,"\t")
      }
      this.serviceResponse = response
    })
  }

  onEditorTCCreated(quill) {
    this.editorTC = quill;
    console.log('Editor de tc listo', quill);
  }
  onEditorPrescriptionCreated(quill) {
    this.editorPrescription = quill;
    console.log('editor de receta listo', quill);
  }
  onEditorAssistanceCertificateCreated(quill) {
    this.editorPrescription = quill;
    console.log('editor de certificado de asistencia listo', quill);
  }

  onEditorMailCreated(quill) {
    this.editorMail = quill;
    console.log('Editor de mail listo', quill);
  }

  startTCEditor() {
    setTimeout(() => {
    }, 2800)
  }

  startPrescriptionEditor() {
    setTimeout(() => {
    }, 2800)
  }

  startMailEditor() {
     setTimeout(() => {
     }, 2800)
  }

  useDefaultPrescriptionModel(){
    this.provider.prescriptionModel="<ul><li>Fecha: 	__PRESCRIPTION_DATE__</li><li>Nombre completo:			__PATIENT_COMPLETE_NAME__</li><li>DNI:									__DOCUMENT_NUMBER__</li><li>Diagnóstico: 					__DIAGNOSES__</li></ul>"
  }

  useDefaultAssistanceCertificateModel(){
    this.provider.assistanceCertificateModel=
      `
        __INTRO_FIRST__ <br>
        Paciente: __PATIENT_NAME__, DNI: __PATIENT_DNI__ <br>
        __DOCTOR_DATA__
        `
  }

  useDefaultMailModel(){
    this.provider.prescriptionModelMail='<p><span style="color: rgb(34, 34, 34);">Muchas gracias por utilizar el servicio de Llamando al Doctor. </span></p><p><br></p><p><span style="color: rgb(34, 34, 34);">En este correo te enviamos:</span></p><ol><li>Receta electrónica con la medicación indicada por el profesional: tenés que imprimirla y luego acercarte a una farmacia para comprar la medicación.</li><li>Indicaciones médicas: con el detalle de cómo administrar la medicación recetada. Seguí con atención las instrucciones.</li><li>Lista de farmacias disponibles para comprar la medicación: buscá tu localidad en el listado adjunto. Si no aparece, podés comprar los medicamentos en cualquier farmacia (como si fuesen de venta libre).</li></ol><p><br></p><p><span style="color: rgb(34, 34, 34);">Si tenés preguntas o sugerencias podés escribirnos a </span><span style="color: rgb(17, 85, 204);">contacto@llamandoaldoctor.com</span><span style="color: rgb(34, 34, 34);"> y te responderemos a la brevedad.</span></p><p><br></p><p><span style="color: rgb(34, 34, 34);">Desde ya muchas gracias.</span></p><p><br></p><p><span style="color: rgb(34, 34, 34);">Equipo de Llamando al Doctor</span></p>'
  }

  addMedicine(index){
    var addedMedicine = this.medicinesTable.splice(index,1)[0];
    this.provider.prescriptionMedicinesModel.push(addedMedicine);
  }

  removeMedicine(index){
    var removedMedicine = this.provider.prescriptionMedicinesModel.splice(index,1)[0];
    this.medicinesTable.push(removedMedicine);
  }

  addDoctor(doctor:any){
    this.providerService.addDoctor(this.provider.id,doctor.id).then((response)=>{
      let n = this.doctors.indexOf(doctor)
      this.providerDoctors.push(doctor)
      this.doctors.splice(n, 1);
    }).catch((err:Response)=>{
      alert(err.json().message);
    })
  }

  removeDoctor(doctor:any){
    this.providerService.removeDoctor(this.provider.id,doctor.id).then((response)=>{
      let n = this.providerDoctors.indexOf(doctor)
      this.doctors.push(doctor)
      this.providerDoctors.splice(n, 1);
    }).catch((err:Response)=>{
      alert(err.json().message);
    })
  }

  addLADDoctors(){
    let priorityCountryParam = (!this.priorityCountry || this.priorityCountry == "" || this.priorityCountry == this.priorityCountryEmptyItemText) ? null : this.priorityCountry;

    if (confirm("Do you want to add all LAD doctors from the selected country to this provider?")){
      this.providerService.addAllDoctors(this.provider.id, priorityCountryParam, true).then((response)=>{
        window.location.reload();
      }).catch((err:Response)=>{
        alert(err.json().message);
      })
    }
  }

  addAllDoctors(){
    let priorityCountryParam = (!this.priorityCountry || this.priorityCountry == "" || this.priorityCountry == this.priorityCountryEmptyItemText) ? null : this.priorityCountry;

    if (confirm("Do you want to add all doctors from the selected country to this provider?")){
      this.providerService.addAllDoctors(this.provider.id, priorityCountryParam, null).then((response)=>{
        window.location.reload();
      }).catch((err:Response)=>{
        alert(err.json().message);
      })
    }
  }

  removeLADDoctors(){
    let priorityCountryParam = (!this.priorityCountry || this.priorityCountry == "" || this.priorityCountry == this.priorityCountryEmptyItemText) ? null : this.priorityCountry;

    if (confirm("Do you want to remove all LAD doctors from this provider?")){
      this.providerService.removeAllDoctors(this.provider.id, priorityCountryParam, true).then((response)=>{
        window.location.reload();
      }).catch((err:Response)=>{
        alert(err.json().message);
      })
    }
  }

  removeAllDoctors(){
    let priorityCountryParam = (!this.priorityCountry || this.priorityCountry == "" || this.priorityCountry == this.priorityCountryEmptyItemText) ? null : this.priorityCountry;

    if (confirm("Do you want to remove all doctors from this provider?")){
      this.providerService.removeAllDoctors(this.provider.id, priorityCountryParam, null).then((response)=>{
        window.location.reload();
      }).catch((err:Response)=>{
        alert(err.json().message);
      })
    }
  }


  addSpecialty(spec:any){
    this.providerService.addSpecialty(this.provider.id,spec.realId).then((response)=>{
      let n = this.specialties.indexOf(spec)
      this.providerSpecialties.push(spec)
      this.specialties.splice(n, 1);
    })
  }

  removeSpecialty(spec:any){
    this.providerService.removeSpecialty(this.provider.id,spec.realId).then((response)=>{
      let n = this.providerSpecialties.indexOf(spec)
      this.specialties.push(spec)
      this.providerSpecialties.splice(n, 1);
    })
  }

  addPlan(plan:any){
    this.provider.addPlan(plan.id)
    this.providerService.update({id:this.provider.id,plans:this.provider.plans})
    .then((response)=>{
      let n = this.plans.indexOf(plan)
      this.providerPlans.push(plan)
      this.plans.splice(n, 1);
    })
  }

  removePlan(plan:any){
    this.provider.removePlan(plan.id)
    var updateBody = {id:this.provider.id,plans:this.provider.plans}
    if (this.provider.defaultPlan == plan.id){
      this.provider.defaultPlan = null;
      updateBody["defaultPlan"] = null;
    }
    this.providerService.update(updateBody)
    .then((response)=>{
      let n = this.providerPlans.indexOf(plan)
      this.plans.push(plan)
      this.providerPlans.splice(n, 1);
    })
  }

  addDefaultValidator(validator:string){
    if(!validator) return;
    if (!this.defaultValidators) this.defaultValidators = []
    this.defaultValidators.push(validator)
    this.defaultValidatorToAdd = ""
    this.providerService.update({id: this.provider.id, defaultValidators: JSON.stringify(this.defaultValidators)})
  }

  removeDefaultValidator(validator:string){
    this.defaultValidators.splice(this.defaultValidators.indexOf(validator), 1)
    this.providerService.update({id: this.provider.id,defaultValidators: JSON.stringify(this.defaultValidators)})
  }

  imageFileAdded(){
    return this.imageChanged || this.headerChanged || this.registrationSelectorImageChanged || this.prescriptionLogoChanged || this.appointmentMailLogoChanged || this.customStyleSheetUrlChanged || this.callBackgroundImageChanged;
  }

  removeLoginValidatorImage() {
    if (confirm("¿Estás seguro de que querés eliminar esta imagen?")){
      this.providerService.update({id:this.provider.id,loginValidatorImage:null}).then(()=>{
        this.urlLoginValidatorImage = null;
        window.location.reload()
      })
    }
  }

  saveSpecialtyTime(specialty,id){
    if(this.specialtiesMaxTime[id])
    {
      var miliseconds = this.specialtiesMaxTime[id]*MILISECONDS
      if(this.specialtiesProviderConfig.length)
      {
        var update = false;
        this.specialtiesProviderConfig.forEach(config => {
          if(config.specialty == specialty.realId)
          {
            update = true;
            this.specialtyProviderService.update(config.id,{provider:config.providerId,specialty:config.specialtyId,maxDuration:miliseconds})
          }
        });
        if(!update)
          this.specialtyProviderService.create({provider:this.provider.id,specialty:specialty.realId,maxDuration:miliseconds})
      }
      else
      {
        this.specialtyProviderService.create({provider:this.provider.id,specialty:specialty.realId,maxDuration:miliseconds})
      }
    }
  }

  protected getConfigDetailUrl(providerId, specialtyId) : string {
    return `/specialtyProviderConfig/${providerId}/specialty/${specialtyId}`;
  };

  editSpecialtySchedule(specialty:any) {
    this.router.navigate([ this.getConfigDetailUrl(this.provider.id, specialty.realId) ]);
  }

  changeDeprecated(provider) {
    let deprecatedText: string;
    provider.deprecated ? deprecatedText = "enable" : deprecatedText = "disable"

    let res = confirm(`Are you sure you want to ${deprecatedText} this provider?`)

    if(res) {
      this.providerService.update({ id: provider.id, deprecated: !provider.deprecated }).then( () => {
        provider.deprecated = !provider.deprecated
      }).catch(err => {
        console.log(err)
      })
    }
  }

  addQuestion() {
    this.questions.push({
      question: "",
      type: "number",
      order: this.questions.length,
      provider: this.provider.id,
      rating: 5,
      language: this.provider.supportedLanguages.length > 0 ? this.provider.supportedLanguages[0].id : this.getProviderLanguage()
    });
  }

  private getProviderLanguage(): string {
    const providerLanguageCode = this.provider.language.split('-')[0];
    return this.allSupportedLanguages.find((language) => language.code === providerLanguageCode);
  }

  onClickQuestionType(index: number, checked): void {
    this.questions[index].rating = checked ? null : 5;
  }

  deleteLastQuestion() {
    this.questions.pop()
  }

  removeQuestion(item){
    this.questions.splice(item, 1)
  }

  moveQuestion(to,item,index){
    let newPos = index - to

    this.questions.splice(index, 1)

    if (newPos < 0) {
      newPos = 0
    } else if (newPos >= this.questions.length) {
      newPos = this.questions.length
    }
    this.questions.splice(newPos, 0, item)
  }

  selectAsDefaultPlan(plan){
    this.providerService.update({id: this.provider.id, defaultPlan: plan.id})
    .then((response)=>{
      this.provider.defaultPlan = plan.id
    })
  }

  isSelectedLanguage(language){
    var lang = this.provider.supportedLanguages.find(o => o.id == language.id)
    return !_.isUndefined(lang)
  }

  chooseSupportedLanguage(ev, language){
    var selectedLanguage = ev.target.checked;
    if(selectedLanguage) return this.addLanguage(language)
    return this.removeLanguage(language)
  }

  addLanguage = function(language:any){
    this.providerService.addLanguage(this.provider.id,language.id).then(() =>{
      this.provider.supportedLanguages.push(language)
    })
  }

  removeLanguage(language:any){
    this.providerService.removeLanguage(this.provider.id,language.id).then(() =>{
      this.provider.supportedLanguages = this.provider.supportedLanguages.filter(l => l.id !== language.id)
    })
  }

  changePrescriptionIntegration(event:any){
    if(event.target.checked) {
      const confirm = window.confirm("Esto sobreescribirá cualquier otro servicio de prescripción activado anteriormente. Desea continuar?");

      if(confirm) {

        if(event.target.name == "Farmalink") {
          return this.setFarmalink();
        }
        if(event.target.name == "Medikit") {
          return this.setMedikit();
        };

      }
      else {
        event.target.checked = false;
        return;
      }

    } else {
      this.newPrescriptionIntegrationType = ""
    }
  }

  setMedikit() {
    return this.providerService.getDoctors(this.provider.id)
    .then( doctors => {
      const needToRegisterDoctors = doctors.some( doctor => _.isEmpty(doctor.medikitDoctorToken));

      if(needToRegisterDoctors) {
        alert("No es posible activar Medikit en el provider ya que se encontraron doctores sin registrar en el servicio. Por favor registrelos e intente nuevamente.");
        location.reload();
      }

      this.useMedikit = true;
      this.useFarmalink = false;
      this.newPrescriptionIntegrationType = "Medikit";
    })
  }

  setFarmalink() {

    if(this.provider.typeId == undefined || this.provider.orgId == undefined || this.provider.farmalinkId == undefined) {
      alert("Missing attributes related with Farmalink, please fill them all.")
      return;
    }

    const confirmation = confirm("Está seguro? Recuerde que cuando Farmalink esté activo, aquellos doctores asignados al proveedor que no tengan la matrícula establecida, serán removidos del mismo.")

    if(confirmation) {
      this.useMedikit = false;
      this.useFarmalink = true;
      this.newPrescriptionIntegrationType = "Farmalink";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/provider/provider.component.ts